export default "__VITE_ASSET__yEaw_x$I__"